import { Component, Input, OnInit } from '@angular/core';


@Component({
    selector: 'app-card-tabs',
    templateUrl: './cardtabs.component.html',
    styleUrls: ['./cardtabs.component.css'],
})
export class CardTabsComponent implements OnInit {

    @Input() tabitems: any;

    menuItems: any[];

    constructor(
    ) {

    }

    ngOnInit() {
        this.menuItems = this.tabitems;
    }






}



// WEBPACK FOOTER //
// ./src/app/components/cardtabs/cardtabs.component.ts